import { ServiceBookItemFormModel } from "../service-book-item.form-model";

export class EventItemFormModel
       extends ServiceBookItemFormModel {

}